import { render, staticRenderFns } from "./DrawRecord.vue?vue&type=template&id=30a55232&scoped=true&"
import script from "./DrawRecord.vue?vue&type=script&lang=js&"
export * from "./DrawRecord.vue?vue&type=script&lang=js&"
import style0 from "./DrawRecord.vue?vue&type=style&index=0&id=30a55232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a55232",
  null
  
)

export default component.exports